import { useGetAdditionalPropertyValue } from './useGetAdditionalPropertyValue';
import { useObjectId } from './useObjectId';
import { useObjectTypeId } from './useObjectTypeId';
export const useAdditionalPropertyValues = propertyNames => {
  const objectId = useObjectId();
  const objectTypeId = useObjectTypeId();
  const getAdditionalPropertyValue = useGetAdditionalPropertyValue();
  const additionalValues = propertyNames.map(propertyName => getAdditionalPropertyValue(propertyName, objectId, objectTypeId));
  return additionalValues;
};